enum CampaignFileType {
  ProcessData = 'ProcessData',
  Other = 'Other',
}

export default CampaignFileType;
